export default __webpack_public_path__ + "static/team10-665938c545ccebb6a82d269526f7696f.webp";